import { gql } from '@apollo/client';

const DEVICE_FRAGMENT = gql`
  fragment DeviceFragment on Device {
    id
    deviceId
    status
    model
    canRunBiotresMCT
    firstStudyDate
    additionalStatus
    lastUsed {
      study {
        info {
          interprettingPhysician {
            id
          }
        }
      }
    }
    isRenewal
    shouldMaintain
    isRunningStudy
    lastSync {
      time
      timezone
      operator
      networkMode
      leadOn
      isCharging
      batteryLevel
      rssi
      sdFree
      fwVersion
      schema
      gprs
    }
    facility {
      id
      name
      contact {
        country
      }
      status
      programs {
        protectPlus
        renewalStock
      }
      timezone
    }
  }
`;

export default DEVICE_FRAGMENT;
